import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const SecondaryMarketPostEventWorkspaceLazy = lazyWithRetry(() => import('./SecondaryMarketPostEventWorkspace'));
export function SecondaryMarketPostEventWorkspaceRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <SecondaryMarketPostEventWorkspaceLazy />
    </Suspense>
  );
}
